var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-circle',{attrs:{"color":_vm.color,"title":_vm._f("translate")(_vm.title)},nativeOn:{"click":function($event){return _vm.$emit('input', !_vm.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }